//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavigationItem from '~sdp-components/Navigation/NavigationItem'

export default {
  components: {
    NavigationItem,
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    goal() {
      const splitpath = this.currentRouteName.split('/')
      if (splitpath.length > 0) {
        return splitpath[0]
      } else {
        return ''
      }
    },
  },
}
